<template>
  <g id="Strap_A-04">
    <rect x="44.6704" y="12.6964" fill="#E6C79C" width="55.2006" height="194.6012"/>
    <g>
      <path fill="#D3B790" d="M72.0818,10.7683c0,0,28.4735,0.2987,29.6841,1.5093s1.5094,25.5419,1.5094,25.5419v11.1317
			H40.8884V37.8195c0,0,0.2992-24.3312,1.5092-25.5418S72.0818,10.7683,72.0818,10.7683z"/>
      <path fill="#D3B790" d="M72.0818,216.8683c0,0,28.4735-0.2988,29.6841-1.5094s1.5094-33.1732,1.5094-33.1732v-11.1318
			H40.8884v11.1318c0,0,0.2987,31.9626,1.5094,33.1732S72.0818,216.8683,72.0818,216.8683z"/>
    </g>
    <g>
      <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="41.97" y1="42.4615" x2="43.0516" y2="42.4615"/>
      <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" stroke-dasharray="2.1113,1.0556" x1="44.1073" y1="42.4615" x2="100.5842" y2="42.4615"/>
      <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="101.112" y1="42.4615" x2="102.1936" y2="42.4615"/>
    </g>
    <g>
      <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="41.97" y1="177.5436" x2="43.0516" y2="177.5436"/>
      <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" stroke-dasharray="2.1113,1.0556" x1="44.1073" y1="177.5436" x2="100.5842" y2="177.5436"/>
      <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="101.112" y1="177.5436" x2="102.1936" y2="177.5436"/>
    </g>
  </g>
</template>

<script>
export default {
  name: 'sdStrap',
  props: ['data'],
  computed: {
    strap() {
      if (this.data) return this.data;
    },
  },
};
</script>
